'use strict'; // var modulo = require('./modulo');

var $floor = Math.floor; // http://262.ecma-international.org/5.1/#sec-5.2

module.exports = function floor(x) {
  // return x - modulo(x, 1);
  return $floor(x);
};